export * from './MMNComponent';
export { type MMNComponentProps } from './MMNComponent.types';
